import * as constants from "./constants";

export const fetchTeacherAssign = (data) => {
  return {
    type: constants.FETCH_TEACHER_ASSIGN,
    data,
  };
};

export const fetchTeacherAssignSuccess = (data) => {
  return {
    type: constants.FETCH_TEACHER_ASSIGN_SUCCESS,
    data: data,
  };
};

export const fetchTeacherAssignError = (data) => {
  return {
    type: constants.FETCH_TEACHER_ASSIGN_ERROR,
    data: data,
  };
};

export const updateTeacherAssign = (data) => {
  return {
    type: constants.UPDATE_TEACHER_ASSIGN,
    payload: data,
  };
};

export const updateTeacherAssignSuccess = (data) => {
  return {
    type: constants.UPDATE_TEACHER_ASSIGN_SUCCESS,
    data: data,
  };
};

export const updateTeacherAssignError = () => {
  return {
    type: constants.UPDATE_TEACHER_ASSIGN_ERROR,
  };
};

export const createTeacherAssign = (data, id) => {
  return {
    type: constants.CREATE_TEACHER_ASSIGN,
    data: data,
  };
};

export const createTeacherAssignSuccess = (data) => {
  return {
    type: constants.CREATE_TEACHER_ASSIGN_SUCCESS,
    data: data,
  };
};

export const createTeacherAssignError = (id) => {
  return {
    type: constants.CREATE_TEACHER_ASSIGN_ERROR,
    id,
  };
};

export const isAddingAction = (data) => {
  return {
    type: constants.IS_ADDING_UPDATE,
    data,
  };
};

export const setStorage = (data) => {
  return {
    type: constants.SET_TEACHER_MANAGER_STATE,
    data,
  };
};
